
// Banners JS

/* global Cookies */
/* global biro_body */


// On page load
jQuery( function( $ ) {

	// Init
	var banner = $( '.biro-banner' );
	if ( banner.length ) {

		// Init
		var banner_id         = banner.data( 'banner-id' );
		var dismissed_banners = Cookies.get( 'dismissed-banners' );
		if ( dismissed_banners === undefined ) {
			dismissed_banners = [];
		} else {
			dismissed_banners = dismissed_banners.split( ',' ).map( Number );
		}

		// Show current banner if not dismissed
		if ( $.inArray( banner_id, dismissed_banners ) === -1 ) {

			banner.slideDown();

		}

		// Dismiss
		biro_body.on( 'click', '.biro-banner-dismiss', function() {

			// Hide
			banner.slideUp();

			// Add ID to cookie
			dismissed_banners.push( banner_id );
			Cookies.set( 'dismissed-banners', dismissed_banners.join( ',' ), { expires: 365 } );

		});

	}

});